import React from 'react';
import { SearchBar } from './search/SearchBar';

export function Hero() {
  return (
    <div className="relative bg-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
            <span className="block">Find the Perfect Food</span>
            <span className="block text-emerald-600">for Your Best Friend</span>
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Discover research-backed recommendations, expert nutrition advice, and comprehensive brand reviews to make the best choice for your dog.
          </p>
          
          <div className="mt-10 max-w-xl mx-auto">
            <SearchBar />
          </div>
        </div>
      </div>
    </div>
  );
}